import { useEffect } from 'react';
import cn from 'classnames';
import { trackCardUpClick } from '@libs/analytics';
import { HorizontalOverflowCarousel } from '@petsmart-ui/sparky';
import PromoCard from '../PromoCard';
import type { CardUpProps } from './types';
import { propsImagesItems } from '../../utils/propsImagesItems';
import { getLinkFromPageId } from '../../utils/getLinkFromPageId';

export default function CardUpArticleVariant({
    cards,
    variant,
    header: title,
    pathname,
    articlesPerView,
    sysId,
}: CardUpProps) {
    const variantName = variant.toLowerCase().replaceAll(' ', '-');

    // Temporary workaround until it's fixed on Sparky side
    useEffect(() => {
        window.dispatchEvent(new Event('resize'));
    }, []);

    return (
        <div data-testid={`card-${variantName}`} key={sysId}>
            <HorizontalOverflowCarousel
                rewindDefault={false}
                perViewDefault={articlesPerView}
                startAtDefault={0}
                defaultGap={32}
                breakpoints={{
                    560: { perView: 1.5, gap: 8 },
                    960: { perView: 2.5, gap: 16 },
                }}
                className={`card-${variantName}`}
            >
                {cards.map((card, index) => {
                    const image = card.previewImage
                        ? card.previewImage
                        : card.image;
                    const link = card.previewDescription
                        ? getLinkFromPageId(card.pageId, card.sysId)
                        : card.linkAction?.link;
                    const header = card.headline || card.header;
                    const description =
                        card.previewDescription || card.description;
                    const linkText = cn(
                        header,
                        description,
                        card.linkAction?.actionText &&
                            card.linkAction?.actionText
                    );
                    return (
                        <HorizontalOverflowCarousel.Item key={card.sysId}>
                            <PromoCard
                                description={description}
                                link={link}
                                imgAlt={image?.webAltText}
                                imageItems={propsImagesItems(image)}
                                header={header}
                                onClick={() => {
                                    trackCardUpClick({
                                        variant,
                                        title,
                                        cardName: header,
                                        cardPosition: index + 1,
                                        link: card.linkAction?.link?.webUrl,
                                        linkText,
                                        pathname,
                                        promoType: `card-${variantName}`,
                                    });
                                }}
                            >
                                {card.linkAction?.link ? (
                                    <p className="sparky-c-text-link">
                                        {card.linkAction?.actionText ??
                                            'Read more'}
                                    </p>
                                ) : null}
                            </PromoCard>
                        </HorizontalOverflowCarousel.Item>
                    );
                })}
            </HorizontalOverflowCarousel>
        </div>
    );
}
